import { render, staticRenderFns } from "./Claims.vue?vue&type=template&id=613da8a5&scoped=true&"
import script from "./Claims.vue?vue&type=script&lang=js&"
export * from "./Claims.vue?vue&type=script&lang=js&"
import style0 from "./Claims.vue?vue&type=style&index=0&id=613da8a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613da8a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
